export default {
    parent: 'ScormLayout', // the layout we'll be using
    url: '',
    abstract: true,
    template: '<ui-view></ui-view>'
};



// WEBPACK FOOTER //
// ./src/app/states/material/index.js